import useResizeObserver from 'hooks/use-resize-observer';
import React, { FC } from 'react';
import styles from './styles.scss';
import Button, { BaseBtnPros } from 'ac-components/ac-btn';
import { useTranslation } from 'hooks/use-translation';



const TrialSection: FC<{ onClick(): void }> = (props) => {
	const { t, transData } = useTranslation('tutors.trial');

	return (
		<section className={styles['ac-trial-info']} id='trial-info'>
			<div className={styles['ac-trial-info-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				<div className={styles['ac-trial-info-content']}>
					<img className={styles['trial-info-img-1']} loading='lazy' src="https://web-data.zmlearn.com/image/5u7kYGv7YqSGZjMQ8Qd9Vx/img_p5_3x.png" alt="" />
				</div>
				<Button className={styles['trial-info-button']} onClick={props.onClick} >{t('tutors.info.button')}</Button>
			</div>
		</section>
	);

}

export default TrialSection
